module.exports = __webpack_public_path__ + "img/TZS09474.3432bfd7.jpeg";